import { Component, effect, input, ChangeDetectionStrategy, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { FeatureKeys } from "company/components/features/feature.service";
import { FeatureEnabledDirective } from "../../../directives/feature-enabled.directive";
import { OneConfigService } from "../../../services/one-config/one-config.service";
import { CreateEntityCmdVisibilityService } from "../create-entity-cmd-visibility.service";
@Component({
	selector: "rl-show-only-dropdown",
	templateUrl: "./show-only-dropdown.component.html",
	styleUrls: ["./show-only-dropdown.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, ReactiveFormsModule, FormsModule, FeatureEnabledDirective]
})
export class ShowOnlyDropdownComponent {
	private readonly _oneConfigService = inject(OneConfigService);
	readonly createCmdVisibilityService = inject(CreateEntityCmdVisibilityService);


	extractedCharIds = input<number[]>(null);

	get disableAllFields() {
		return this.createCmdVisibilityService.computedShowAll();
	}

	featureKeys: typeof FeatureKeys = FeatureKeys;
	constructor() {
		effect(() => {
			const extractedCharIds = this.extractedCharIds();
			this.createCmdVisibilityService.setExtractedChars(extractedCharIds);
		});
	}

}
